// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5811":"cd4342b83df5291f","6987":"6a456c710fd141c9"}[chunkId] + ".js";
};